import { render, staticRenderFns } from "./officialAccMenu.vue?vue&type=template&id=0c990500&scoped=true&"
import script from "./officialAccMenu.vue?vue&type=script&lang=js&"
export * from "./officialAccMenu.vue?vue&type=script&lang=js&"
import style0 from "./officialAccMenu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./officialAccMenu.vue?vue&type=style&index=1&id=0c990500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c990500",
  null
  
)

component.options.__file = "officialAccMenu.vue"
export default component.exports